import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retryDlqEntry, resolveDlqEntry } from '../api';
import { useToast } from '../../../common/hooks';

export const useDlqActions = () => {
    const queryClient = useQueryClient();
    const { success: successToast, error: errorToast } = useToast();
    const [busyId, setBusyId] = useState(null);

    const invalidate = () => {
        queryClient.invalidateQueries({ queryKey: ['operations'] });
    };

    const retry = useMutation({
        mutationFn: async (id) => retryDlqEntry(id),
        onSuccess: () => {
            successToast('عملیات به صف برگشت داده شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در برگرداندن عملیات');
        },
    });

    const resolve = useMutation({
        mutationFn: async ({ id, body }) => resolveDlqEntry(id, body),
        onSuccess: () => {
            successToast('نتیجه ثبت شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در ثبت نتیجه');
        },
    });

    const runRetry = (id) => {
        setBusyId(id);
        retry.mutateAsync(id).finally(() => setBusyId(null));
    };

    const runResolve = (id, body) => {
        setBusyId(id);
        resolve.mutateAsync({ id, body }).finally(() => setBusyId(null));
    };

    return { retry: runRetry, resolve: runResolve, busyId };
};

export default useDlqActions;